/**
 * This is where all the authorization login is stored
 */
import { Authorization } from '~services';

export default function UserHasPermissions(router) {
    /**
     * Before each route we will see if the current user is authorized
     * to access the given route
     */
    router.beforeEach((to, from, next) => {
        let authorized = false;

        /**
         * Remember that access object in the routes? Yup this why we need it.
         *
         */

        if (to && to.meta.access !== undefined) {
            authorized = Authorization.authorize(
                to.meta.access.requiresLogin,
                to.meta.access.requiredPermissions
            );

            if (authorized === 'loginIsRequired' && to.name !== 'auth.login') {
                return next({ path: '/login' });
            }

            if (authorized === 'notAuthorized' && to.name !== 'auth.login') {
                /**
                 * Redirects to a "default" page
                 */
                return next({ path: '/login' });
            }
        }
        /**
         * Everything is fine? Let's to the page then.
         */
        next();
    });
}
